import React from "react";
import { WorkflowFooter } from "./WorkflowFooter";

export function CompletionScreen({ onRestart, collectedAnswers, onHome }) {
  const count = collectedAnswers ? collectedAnswers.length : 0;

  return (
    <div className="screen completion-screen nx-screen">
      <div className="completion-content">

        {/* Animated checkmark — gold stroke */}
        <div className="checkmark-wrapper">
          <svg className="checkmark-svg nx-checkmark-svg" viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg">
            <circle className="checkmark-circle nx-checkmark-circle" cx="26" cy="26" r="24" fill="none" />
            <path className="checkmark-check nx-checkmark-check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
          </svg>
        </div>

        <h1 className="nx-completion-title">Report Submitted</h1>

        {count > 0 && (
          <div className="nx-completion-stat">
            <span className="nx-completion-stat-num">{count}</span>
            <span className="nx-completion-stat-label">
              {count === 1 ? "question answered" : "questions answered"}
            </span>
          </div>
        )}

        <p className="nx-completion-message">
          Your end of day report has been recorded.<br/>
          Thank you.
        </p>

      </div>

      {/* Workflow navigation — large operational buttons at bottom */}
      <WorkflowFooter
        showBack={false}
        onHome={onHome || onRestart}
        homeLabel="Return to Home"
      />
    </div>
  );
}
